import { Component, OnInit } from '@angular/core';
import {WhatIsAnimaCloseAction, WhatIsAnimaModalComponent} from '../what-is-anima-modal/what-is-anima-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-home-hero',
  templateUrl: './home-hero.component.html',
  styleUrls: ['./home-hero.component.scss']
})
export class HomeHeroComponent implements OnInit {

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private deviceService: DeviceDetectorService,
  ) { }

  ngOnInit(): void {
  }
  get isMobile() {
    return this.deviceService.isMobile();
  }
  openWhatIsModal() {
    const modalRef = this.modalService.open(WhatIsAnimaModalComponent, {
      centered: true,
      windowClass: 'modal what-is-anima bg-transparent',
      backdrop: 'static',
      keyboard: true
    });
    modalRef.componentInstance.data = {};
    modalRef.result.then(
      (res) => {
        if (res === WhatIsAnimaCloseAction.startTest) {
          return this.goToTest();
        }
      }
    );
  }
  async goToTest() {
    return this.router.navigate(
      ['cs']
    );
  }

}
